import {GET_COUNTRIES_REQ, GET_COUNTRIES_REQ_FAIL} from "./countriesTypes";
import axios from "axios";

export const countriesAction = (countriesData) => {

    return {
        type: GET_COUNTRIES_REQ,
        payload: countriesData
    }

}
export const countriesActionFail = (error) => {
    return {
        type: GET_COUNTRIES_REQ_FAIL,
        payload: error
    }
}

export const getCountries = () => {
    return (dispatch) => {
        axios.get(process.env.REACT_APP_CUT_REG_BASE_URL + '/countries/')
            .then(response => {
                dispatch(countriesAction(response.data))
            }).catch(error => {
            dispatch(countriesActionFail(error.data))
        })
    }
}
